// src/utils/avatar.js
export function getDiceBearAvatar(seed) {
  return `https://api.dicebear.com/9.x/adventurer/svg?seed=${encodeURIComponent(
    seed || "default"
  )}`;
}

export function getUserAvatar(user) {
  if (user?.avatar_url && user.avatar_url.trim() !== "") {
    return user.avatar_url;
  }

  return getDiceBearAvatar(user?.user_uuid || user?.id || user?.sub || "default");
}